<template>
    <Swiper navigation pagination :modules="[Navigation, Pagination, Thumbs]">
        <slot></slot>
    </Swiper>
</template>

<script setup>
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import { Swiper } from 'swiper/vue';
</script>
